import { render, staticRenderFns } from "./PagoPendiente.vue?vue&type=template&id=20bbb5e5&scoped=true"
import script from "./PagoPendiente.vue?vue&type=script&lang=js"
export * from "./PagoPendiente.vue?vue&type=script&lang=js"
import style0 from "./PagoPendiente.vue?vue&type=style&index=0&id=20bbb5e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bbb5e5",
  null
  
)

export default component.exports